package org.gymly.auth

import kotlin.js.Date

actual fun currentEpochMs(): Long = Date.now().toLong()
